import React from 'react';
import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { Entity } from '@backstage/catalog-model';

function isGroupEntity(entity: Entity): boolean {
  return entity.kind.toLowerCase() === 'group';
}

const groupMembersContent = EntityContentBlueprint.make({
  name: 'group-members',
  params: {
    path: '/members',
    title: 'Membros',
    filter: isGroupEntity,
    loader: async () =>
      import('./components/GroupMembersTable').then(m =>
        compatWrapper(React.createElement(m.GroupMembersTable)),
      ),
  },
});

const groupMembersPlugin = createFrontendPlugin({
  pluginId: 'group-members',
  extensions: [groupMembersContent],
});

export default groupMembersPlugin;
